import { render, staticRenderFns } from "./ReferralStartEarningBtn.vue?vue&type=template&id=0342d5d6&"
import script from "./ReferralStartEarningBtn.vue?vue&type=script&lang=js&"
export * from "./ReferralStartEarningBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports